import { Component, OnInit, OnDestroy, ViewChild, Input, Output, EventEmitter, NgZone } from '@angular/core';
import { IonContent } from '@ionic/angular';  // renamed from Content

import { TranslateService } from '@ngx-translate/core';
import { ApiService } from 'src/app/services/api/api.service';
import { CommonService } from 'src/app/services/common/common.service';
import { GlobalService } from 'src/app/services/global/global.service';
import { ApiReturn } from 'src/app/services/api/apireturn';

// import { Events } from '@ionic/angular';  // deprecated in Ionic 5
import { Events } from 'src/app/services/events/events.service';  // workaround for events

/**
 * Contains the Loading and Error information that is typically used at the top of every screen
 */

 // selector: 'app-myloading'
@Component({
  selector: 'myloading',
  templateUrl: './myloading.component.html',
  styleUrls: ['./myloading.component.scss'],
})
export class MyloadingComponent implements OnInit, OnDestroy  {

  @ViewChild(IonContent) content: IonContent;   
  // https://toddmotto.com/component-events-event-emitter-output-angular-2
  @Input() pageName:string; //@Input('pageName') pageName;
  @Output() outIsPageReady: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() outRefreshPage: EventEmitter<boolean> = new EventEmitter<boolean>();
  
  consoleLog:boolean = false;

  public isPageLoading:boolean = false; // true;
  public isPageError:boolean = false;
  public isPageReady:boolean = false;
  public ProcessingText:string = "";
  public ApiReturn:ApiReturn = new ApiReturn();

  public apiResponseFlag:boolean = false;
  public ErrorSummary:string = "";
  public ErrorDetail:string = "";
  public hideErrorDetails:boolean = true;

  public denyDueToGeofence:boolean = false;
  public isCheckingGeofence:boolean = false; // only need to set this if it is done directly (eg. Monitor), rather than indirectly (e.g. Report, Support, etc.)

  constructor(
      public globalProvider: GlobalService
    , public events: Events
    , public zone: NgZone 
    // public navCtrl: NavController, public navParams: NavParams
  ) 
  {
    this.consoleLog = this.globalProvider.consoleLog_myloading;
    if (this.consoleLog) console.log('myloading.ctor - LifeCycle');
  }

  // ----------------------------------------------------
  // -------- COMPONENT LIFE-CYCLE EVENTS  --------------
  // ----------------------------------------------------
  ngOnInit() // ngAfterViewInit()
  {
    if (this.consoleLog) console.log('myloading.ngOnInit - ' + this.pageName + ' - LifeCycle');
  }

  // this IS called -- just before the component is removed
  ngOnDestroy() 
  { 
    if (this.consoleLog) console.log('myloading.ngOnDestroy - ' + this.pageName + ' - LifeCycle');
  }

  // ----------------------------------------------------
  // ----------------  COMPONENT LOGIC  -----------------
  // ----------------------------------------------------

  SetPageSending(send0complete1error9, ProcessingText=null)
  {
    this.zone.run(() => {
      this.isPageLoading = false;
      //this.isPageReady = false;
      this.isPageError = false;
      if (send0complete1error9 === 0) { this.isPageLoading = true; }
      if (send0complete1error9 === 1) {  }
      if (send0complete1error9 === 9) { this.isPageError = true; }

      this.ProcessingText = ProcessingText;  // this can be an error message etc.
      //this.outIsPageReady.emit(this.isPageReady); // send to parent page
    });
  }


  SetPageLoading(context:string, load0ready1error9:number, ProcessingText=null, OtherDetail:string=null) //:boolean
  {
    // this simple loading component became more complicated over time (unnecesarily so)
    // ToDo:  consider simplifying this later and separating out the life-cycle concerns

    if ((this.consoleLog) || (load0ready1error9 === 9)) console.log('myloading.SetPageLoading(' + context +  '):' + load0ready1error9 + " - ", ProcessingText);
    
    this.zone.run(() => {
      this.denyDueToGeofence = false;  // initialize geofence here -- it may be reset after loading call
      this.isPageLoading = false;
      this.isPageReady = false;
      this.isPageError = false;
      if (load0ready1error9 === 0) { this.isPageLoading = true; }
      if (load0ready1error9 === 1) { this.isPageReady = true; }
      if (load0ready1error9 === 9) { this.isPageError = true; }

      if (load0ready1error9 === 9)
      {
        this.SetApiReturnInfo(context, load0ready1error9, ProcessingText, OtherDetail);
      }
      else
      {
        this.ProcessingText = ProcessingText;
      }

      this.outIsPageReady.emit(this.isPageReady); // send to parent page
      //return this.isPageReady;
    });
  }

  private SetApiReturnInfo(context:string, load0ready1error9:number, ProcessingText=null, OtherDetail:string=null)
  {
    // this simple loading component became more complicated over time (unnecesarily so)
    // ToDo:  consider simplifying this later and separating out the life-cycle concerns

    this.hideErrorDetails = true;
    this.apiResponseFlag = false;
    this.ApiReturn.Initialize();

    this.ErrorSummary = "";
    this.ErrorDetail = "";

    if ((ProcessingText) && (ProcessingText.ApiReturn))
    {
    // API error occurred...
      this.apiResponseFlag = true;
      this.ApiReturn.SetApiReturn(ProcessingText.ApiReturn);

      if (!this.ApiReturn.ApiAdditionalInfo) { this.ApiReturn.ApiAdditionalInfo = context + " ... " + OtherDetail; }
    }
    else if (ProcessingText)
    {
      // Unhandled Ambit API error occurred... (or could be google API error)
      this.apiResponseFlag = false;
      this.ApiReturn.ApiReturnText = ProcessingText;
      this.ApiReturn.ApiAdditionalInfo = context + " ... " + OtherDetail;
    }
    else
    {
      // Unexpected error
      this.apiResponseFlag = false;
      this.ApiReturn.ApiReturnText = "Something went wrong - Please try again";
      this.ApiReturn.ApiAdditionalInfo = context + " ... " + OtherDetail;
    }

    // Pick out the part for display (we can use the rest of the API return object for debugging)
    if (this.ApiReturn.ApiReturnText.startsWith('Http failure response'))
    {
      // make the main message simpler
      this.ErrorSummary = "Unable to send message - Please try again";
      this.ErrorDetail = this.ApiReturn.ApiReturnText + " - " + this.ApiReturn.ApiAdditionalInfo;
    } 
    else
    {
      // make the main message simpler for display
      this.ErrorSummary = this.ApiReturn.ApiReturnText;
      this.ErrorDetail = this.ApiReturn.ApiAdditionalInfo;
    }

    console.warn('myloading.SetApiReturnInfo(' + context +  '):' + this.ErrorSummary, this.ApiReturn);
  }

  public btnToggleErrorDetails()
  {
    this.hideErrorDetails = !this.hideErrorDetails;
  }



  public SetCheckingGeofence(isCheckingGeofence:boolean)
  {
    this.isCheckingGeofence = isCheckingGeofence;

    /*
    if (isCheckingGeofence)
    {
      this.isPageReady = false;
    }
    */
  }

  public SetDenyDueToGeofence(denyDueToGeofence:boolean)
  {
    this.denyDueToGeofence = denyDueToGeofence;

    if (!denyDueToGeofence)
    {
      this.isPageReady = false;
      // this.outIsPageReady.emit(this.isPageReady); // send to parent page
    }
  }

  public btnGeofenceTryAgain()
  {
    // alert("ToDo: notify parent page that it needs to run initialization again");
    console.log("myloading.btnGeofenceTryAgain: outRefreshPage " + this.pageName);
    this.outRefreshPage.emit(true);
  }

  
}
